import { feedback } from "../../js/path";
import moment from "moment";

export default {
  data() {
    return {
      params: "&page=1",
      filter: null,
      tableData: [],
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      currentPage: 1,
      fields: [
        {
          key: "id",
        },
        {
          key: "name",
        },
        {
          key: "email",
        },
        {
          key: "mobile_number",
          class: "c_touchpt_header",
        },
        {
          key: "message",
          class: "w-250",
        },
        {
          key: "age",
        },
        {
          key: "age_type",
        },
        {
          key: "disease",
        },
        {
          key: "gender",
        },
        {
          key: "doctor_name",
          class: "c_touchpt_header",
        },
        {
          key: "mail",
        },
        {
          key: "whatsapp",
        },
        {
          key: "created_at",
          label: "Raised On",
          class: "c_touchpt_header",
          visible: true,
          formatter: (value) => {
            return moment(String(value)).format("llll");
          },
        },
        {
          key: "is_email_opened",
          label: "Email Opened",
        },
        {
          key: "is_connect",
          label: "Connected",
        },
        {
          key: "is_query_solved",
          label: "Query Solved",
          class: "c_touchpt_header",
        },
      ],
      activeTab: "all",
      submitted: false,
      emailModal: false,
      whatsappModal: false,
      emailform: {
        email: "",
        message: "",
        mobile_number: "",
        name: "",
        id: "",
      },
      whatsappform: {
        id: "",
        doctor_name: "",
        doctor_mobile_number: "",
        name: "",
        complaint: "",
        mobile_number: "",
      },
      profileUrl:
        process.env.VUE_APP_ENV == "development"
          ? "https://dev2.mymedisage.com/profile/"
          : process.env.VUE_APP_ENV == "staging"
          ? "https://staging.mymedisage.com/profile/"
          : process.env.VUE_APP_ENV == "production"
          ? "https://mymedisage.com/profile/"
          : "https://dev2.mymedisage.com/profile/",
    };
  },
  methods: {
    searchFor() {
      if (this.filter.length > 2) {
        this.currentPage = 1;
        this.fetchData();
      } else if (this.filter.length == 0) {
        this.currentPage = 1;
        this.fetchData();
      }
    },
    search(event) {
      if (this.filter.length > 2) {
        if (event.keyCode == 13) {
          this.currentPage = 1;
          this.fetchData();
        }
      } else if (this.filter.length == 0) {
        this.currentPage = 1;
        this.removeQueryParam();
        this.fetchData();
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    openMailModal(item) {
      this.emailform.message = item.message;
      this.emailform.email = item.doctor_email;
      this.emailform.mobile_number = item.mobile_number;
      this.emailform.name = item.name;
      this.emailform.id = item.id;
      this.emailModal = true;
    },

    openWhatsappModal(item) {
      this.whatsappform.id = item.id;
      this.whatsappform.name = item.name;
      this.whatsappform.doctor_name = item.doctor_name;
      this.whatsappform.doctor_mobile_number = item.doctor_mobile_number;
      this.whatsappform.mobile_number = item.mobile_number;
      this.whatsappform.complaint = item.message;      
      this.whatsappModal = true;
    },

    clearEmailModal() {
      this.submitted = false;
      this.emailform.email = "";
      this.emailform.message = "";
    },

    clearWhatsappModal() {
      this.submitted = false;
      this.whatsappform.doctor_mobile_number = "";
      this.whatsappform.message = "";
    },

    removeQueryParam() {
      let uri = window.location.toString();
      if (uri.indexOf("?") > 0) {
        let clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
      }
    },

    async sendMail() {
      try {
        this.submitted = true;
        this.$v.emailform.$touch();
        if (this.$v.emailform.$invalid) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Please fill all required fields with valid information.",
          });
          return false;
        }
        this.$store.commit("loader/updateStatus", true);
        console.log("huih");
        const dataAppend = new FormData();
        for (var key in this.emailform) {
          dataAppend.append(key, this.emailform[key]);
        }
        const url = feedback?.sendMail;
        const res = await this.postRequest(url, dataAppend);
        if (res.status) {
          this.emailModal = false;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: res.message,
          });
        }
        this.key += 1;
        this.fetchData();
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },

    async sendWhatsapp() {
      try {
        this.submitted = true;
        this.$v.emailform.$touch();
        
        if (this.$v.whatsappform.$invalid) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Please fill all required fields with valid information.",
          });
          return false;
        }
        this.$store.commit("loader/updateStatus", true);
        const dataAppend = new FormData();
        for (var key in this.whatsappform) {
          dataAppend.append(key, this.whatsappform[key]);
        }
        const url = feedback?.sendWhatsapp;
        const res = await this.postRequest(url, dataAppend);
        if (res.status) {
          this.whatsappModal = false;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: res.message,
          });
        }
        this.key += 1;
        this.fetchData();
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },

    async updateQueryStatus(id) {
      this.$store.commit("loader/updateStatus", true);
      try {
        let index = this.tableData.data.findIndex((e) => e.id == id);
        const url = feedback?.updateQueryStatus + "/" + id;
        const data = await this.postRequest(url, {
          is_query_solved: !this.tableData.data[index].is_query_solved,
        });
        if (data.status) {
          const responseData = data.response;
          this.tableData.data[index] = responseData;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
        this.key += 1;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },
    async fetchData() {
      this.$store.commit("loader/updateStatus", true);
      try {
        let url = feedback?.getPatientQuery;
        url = `${url}?search=${this.filter ?? ""}`;
        this.getUrl();
        url += this.params;
        const data = await this.getRequest(url);
        if (data.status) {
          this.tableData = data?.response;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data ? err?.data?.message : "Please try again!",
        });
        console.log(err);
      }
      this.$store.commit("loader/updateStatus", false);
    },
    getUrl() {
      let url = new URL(window.location);
      if (this.filter != null && this.filter != "") {
        url.searchParams.has("search")
          ? url.searchParams.set("search", this.filter)
          : url.searchParams.append("search", this.filter);
      } else {
        url.searchParams.delete("search");
      }
      if (this.currentPage != null && this.currentPage != "") {
        url.searchParams.has("page")
          ? url.searchParams.set("page", this.currentPage)
          : url.searchParams.append("page", this.currentPage);
      } else {
        url.searchParams.set("page", 1);
      }
      url.search = url.searchParams;
      url = url.toString();
      history.pushState({}, null, url);
    },
  },
  watch: {
    currentPage: {
      handler: function (v) {
        if (v != "" && v != null) {
          this.params = `&page=${v}`;
          this.fetchData(v);
        }
      },
    },
    filter(v) {
      if (v.length == 0) {
        this.removeData();
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.activeTab = this.$route.query.filter;
    }
    if (this.$route.query.search) {
      this.filter = this.$route.query.search;
    }
    if (this.$route.query.page && this.$route.query.page != 1) {
      this.currentPage = parseInt(this.$route.query.page);
    } else {
      this.fetchData(this.activeTab);
    }
  },
};
